import styled from "styled-components";
import { Container } from "@mui/material";

const CenteredContainer: any = styled(Container)`
  text-align: center;
`;

export default CenteredContainer;
